import httpClient from '@/http-client'
export const store = data => {
  return httpClient
    .post('/api/hospital-profiles', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const get = (Options = {}) => {
  return httpClient
    .get('/api/hospital-profiles', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const update = data => {
  return httpClient
    .put(`/api/hospital-profiles/${data.id}`, data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export const destroy = id => {
  return httpClient
    .delete(`/api/hospital-profiles/${id}`)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}
export default {
  store,
  get,
  update,
  destroy
}
